//@ts-nocheck
import React, { useState, useEffect } from 'react';
import {
	EditBase,
	TopToolbar,
	useGetOne,
	useRecordContext,
	useUpdate,
	useNotify,
} from 'react-admin';
import {
	Card,
	CardContent,
	Typography,
	Grid,
	Stack,
	Switch,
	TextField,
	Select,
	MenuItem,
	FormControlLabel,
	Button,
	FormControl,
	InputLabel,
	Box,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useParams, useNavigate } from 'react-router';
import { ConnectorStatusLst, IStatus, updateConnectorStatus } from '../../Services/connector';
import { ConnectorAccountsList } from './ConnectorAccountList';
import BetaRequestsPanel from './BetaRequestsPanel';
const Breadcrumb = () => {
	const record = useRecordContext();
	return (
		<TopToolbar>
			<Typography variant="subtitle1">
				Home / Connectors / {record ? record.name : 'Edit'}
			</Typography>
		</TopToolbar>
	);
};

const w = window as any;

export const ConnectorEdit = (props: any) => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { data: record, isLoading: isRecordLoading } = useGetOne('connectors', {
		id,
	});
	const [update, { isLoading: isUpdating }] = useUpdate();
	const notify = useNotify();

	const [isMigrable, setIsMigrable] = useState(false);
	const [processVersion, setProcessVersion] = useState('1.0');
	const [version, setVersion] = useState('');
	const [status, setStatus] = useState<number>(200);
	const [isStatusSaving, setIsStatusSaving] = useState(false);

	useEffect(() => {
		if (record) {
			setIsMigrable(record.isMigrable || false);
			setProcessVersion(record.processVersion || '1.0');
			setVersion(record.version || '');
			setStatus(record.status || 200);
		}
	}, [record]);

	const getStatus = (statusId: number): IStatus => {
		const status = ConnectorStatusLst.find((s: any) => s.id === statusId);
		return status ? status : { id: 0, name: 'Unknown', color: '#000' };
	};

	const handleSave = () => {
		update(
			'connectors',
			{
				id: record.id,
				data: { isMigrable, processVersion, version },
				previousData: record,
			},
			{
				onSuccess: () => {
					notify('Connector mis à jour', { type: 'success' });
				},
				onError: (error: any) => {
					notify(`Erreur: ${error.message}`, { type: 'error' });
				},
			}
		);
	};

	if (isRecordLoading || !record) return null;

	const logoUrl = `${w.FRONT_URL}/img/connectors-logos/${record.sku}.svg`;

	return (
		<EditBase {...props}>
			<React.Fragment>
				<Breadcrumb />
				{/* Utilisation d'une grille à deux colonnes */}
				<Grid container spacing={2}>
					{/* Colonne principale avec les projets associés */}
					<Grid item xs={8}>
						<ConnectorAccountsList sku={record.sku} />
						<BetaRequestsPanel sku={record.sku} />
					</Grid>
					<Grid item xs={4}>
						<Card>
							<CardContent>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 8,
										marginBottom: 16,
									}}
								>
									<div>
										<img
											src={logoUrl}
											alt=""
											style={{
												width: 25,
												height: 25,
												objectFit: 'contain',
											}}
										/>
									</div>
									<Typography variant="h6" gutterBottom>
										{record?.name}
									</Typography>
								</div>

								<Stack spacing={1}>
									{[
										{ label: 'Sku:', value: record?.sku },
										{ label: 'Sku Parent:', value: record?.skuParent },
										{
											label: 'Status:',
											value: getStatus(record?.status).name,
										},
										{ label: 'Process Version:', value: record?.processVersion },
										{ label: 'Version:', value: record?.version },
										{ label: 'Secret ID:', value: record?.secretId },
										{ label: 'Api URL:', value: record?.apiUrl },
										{
											label: 'Artifact Registry Image:',
											value: record?.artifactRegistryImage,
										},
									].map((item) => (
										<Stack
											key={item.label}
											direction="row"
											spacing={1}
											alignItems="flex-start"
										>
											<Typography
												variant="body2"
												color="textSecondary"
												style={{ width: 200, flexShrink: 0 }} // Largeur fixe pour alignement
											>
												{item.label}
											</Typography>
											<Typography variant="body1">
												{item.value || '—'}
											</Typography>
										</Stack>
									))}
								</Stack>
							</CardContent>
						</Card>

						{/* Card d'édition */}
						<Card sx={{ mt: 2 }}>
							<CardContent>
								<Typography variant="h6" gutterBottom>
									Configuration
								</Typography>
								<Stack spacing={2}>
									<FormControl fullWidth size="small">
										<InputLabel>Statut</InputLabel>
										<Select
											value={status}
											label="Statut"
											disabled={isStatusSaving}
											onChange={async (e) => {
												const next = Number(e.target.value);
												setStatus(next);
												setIsStatusSaving(true);
												try {
													await updateConnectorStatus(record.id, next);
													notify('Statut mis à jour', { type: 'success' });
												} catch (err: any) {
													notify(`Erreur: ${err?.message || 'unknown'}`, { type: 'error' });
													setStatus(record.status || 200);
												} finally {
													setIsStatusSaving(false);
												}
											}}
										>
											{ConnectorStatusLst.map((s: IStatus) => (
												<MenuItem key={s.id} value={s.id}>
													{s.name}
												</MenuItem>
											))}
										</Select>
									</FormControl>

									<FormControlLabel
										control={
											<Switch
												checked={isMigrable}
												onChange={(e) => setIsMigrable(e.target.checked)}
											/>
										}
										label="Migration automatique autorisée"
									/>

									<FormControl fullWidth size="small">
										<InputLabel>Process Version</InputLabel>
										<Select
											value={processVersion}
											label="Process Version"
											onChange={(e) => setProcessVersion(e.target.value)}
										>
											<MenuItem value="1.0">1.0</MenuItem>
											<MenuItem value="2.0">2.0</MenuItem>
										</Select>
									</FormControl>

									<TextField
										label="Version"
										value={version}
										onChange={(e) => setVersion(e.target.value)}
										size="small"
										fullWidth
										placeholder="ex: 2.1.0"
									/>

									<Stack direction="row" spacing={2}>
										<Button
											variant="contained"
											onClick={handleSave}
											disabled={isUpdating}
										>
											{isUpdating ? 'Enregistrement...' : 'Enregistrer'}
										</Button>
										<Button
											variant="outlined"
											startIcon={<SettingsIcon />}
											onClick={() => navigate(`/connectors/${id}/config`)}
										>
											Configuration avancée
										</Button>
									</Stack>
								</Stack>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</React.Fragment>
		</EditBase>
	);
};
